/**
 * @flow weak
 */

export const SELECT_EVENT = 'SELECT_EVENT';

export const selectEvent = (eventId) => {
  return {
    type: SELECT_EVENT,
    eventId
  };
};



// WEBPACK FOOTER //
// ./src/modules/event/actions.js